import { useDelayUnmount } from "./hooks/useDelayUnmount";
import { useAppStore } from "@/common/store/appStore";
import { GlobalSearch } from "@/components/search/GlobalSearch";
import "./AnimatedSearch.scss";

export const AnimatedSearch = () => {
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const shouldRenderChild = useDelayUnmount(isSearchBarOpen);

  if (shouldRenderChild) {
    return (
      <div className={`animatedSearch ${isSearchBarOpen ? "animatedSearchOpened" : "animatedSearchClosed"}`}>
        <GlobalSearch />
      </div>
    );
  }

  return null;
};
